import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { createLabelProperties } from './createLabelProperties';
import { editLabelProperties } from './editLabelProperties';

export const workflows: WorkflowOptions[] = [
  createLabelProperties,
  editLabelProperties,
  ...Object.values(generateAssetStatusWorkflow('labelProperties')),
];

export default workflows;
